import React, { useEffect, useState } from 'react';
import { useI18n } from '../../utils/i18n';
import { getFeatures } from '../../utils/featuresCache';
import { ladeEinstellungen, useBenutzerEinstellungen } from '../../services/benutzerEinstellungen';
import useSofortSpeichern from './useSofortSpeichern';
import { DARSTELLUNGEN } from '../../utils/darstellung';
import './einstellungen.css';

// #567: Wahl der Darstellung (#565), im Einstellungs-Dialog und im
// Einstellungs-Sheet der Mobilansicht.
//
// Drei Möglichkeiten: Modern, Klassisch und „Vorgabe der Installation“. Die
// Vorgabe nimmt den Schlüssel heraus (`null`), danach gilt wieder, was im
// Reiter „Features“ steht. Gespeichert wird sofort, EinstellungenAbgleich
// wendet den neuen Stand an. Die Seite dahinter ist damit selbst die
// Vorschau; die kleinen Farbfelder zeigen jede Darstellung unabhängig von
// der gerade aktiven.
const VORGABE = 'vorgabe';

export default function DarstellungWahl({ idPraefix = 'einst' }) {
  const { t } = useI18n();
  const einstellungen = useBenutzerEinstellungen();
  // Vorgabe der Installation, für den Hinweis „zurzeit …“
  const [vorgabe, setVorgabe] = useState(null);
  const { speichert, speichere } = useSofortSpeichern();

  useEffect(() => {
    let abgebrochen = false;
    // Meist schon geladen (EinstellungenAbgleich); sonst hier nachholen
    ladeEinstellungen().catch(() => null);
    getFeatures().then((f) => {
      if (!abgebrochen) setVorgabe(DARSTELLUNGEN.includes(f && f.darstellung) ? f.darstellung : 'modern');
    });
    return () => { abgebrochen = true; };
  }, []);

  // null = Stand noch nicht da; dann ist nichts angehakt und nichts wählbar
  const gewaehlt = einstellungen ? (DARSTELLUNGEN.includes(einstellungen.darstellung) ? einstellungen.darstellung : VORGABE) : null;

  const waehle = (wert) => {
    if (wert === gewaehlt) return;
    speichere({ darstellung: wert === VORGABE ? null : wert });
  };

  const name = (d) => t(`darstellung.${d}`, d === 'klassisch' ? 'Klassisch' : 'Modern');
  const optionen = [
    { wert: 'modern', titel: name('modern'), vorschau: 'modern' },
    { wert: 'klassisch', titel: name('klassisch'), vorschau: 'klassisch' },
    {
      wert: VORGABE,
      titel: t('einstellungen.darstellungVorgabe', 'Vorgabe der Installation'),
      hinweis: vorgabe ? t('einstellungen.darstellungZurzeit', 'zurzeit {name}').replace('{name}', name(vorgabe)) : null,
      vorschau: vorgabe || 'modern'
    }
  ];

  return (
    <div className="einst-darstellung" role="radiogroup" aria-label={t('einstellungen.darstellung', 'Darstellung')}>
      {optionen.map((o) => {
        const aktiv = gewaehlt === o.wert;
        return (
          <label key={o.wert} className={`einst-darstellung__wahl${aktiv ? ' einst-darstellung__wahl--aktiv' : ''}`}>
            <input
              type="radio"
              name={`${idPraefix}-darstellung`}
              value={o.wert}
              checked={aktiv}
              disabled={gewaehlt === null || speichert}
              onChange={() => waehle(o.wert)}
            />
            <span className={`einst-vorschau einst-vorschau--${o.vorschau}`} aria-hidden="true">
              <span className="einst-vorschau__leiste" />
            </span>
            <span className="einst-darstellung__text">
              <span className="einst-darstellung__titel">{o.titel}</span>
              {o.hinweis && <span className="einst-darstellung__hinweis">{o.hinweis}</span>}
            </span>
          </label>
        );
      })}
    </div>
  );
}
